export class HomeVisibleLinks {

	public Dashboard:boolean = false;
	public Inbox:boolean = false;
	public Custommers:boolean = false;
	public Suppliers:boolean = false;
	public Prospects:boolean = false;
	public Products:boolean = false;
	public PriceLists:boolean = false;
	public Stock:boolean = false;
	public Sales:boolean = false;
	public FrequencyDocuments:boolean = false;
	public SaleRows:boolean = false;
	public Purchases:boolean = false;
	public PurchaseDocuments:boolean = false;
	public PurchaseDocumentRows:boolean = false;
	public Bank:boolean = false;
	public Bookkeeping:boolean = false;
	public Crm:boolean = false;
	public Projects:boolean = false;
	public Calendar:boolean = false;
	public Tasks:boolean = false;
	public Car:boolean = false;
	public Settings:boolean = true;

	public constructor(data?:any) {
		if (!data) return;
		this.Dashboard = data.Dashboard;
		this.Inbox = data.Inbox;
		this.Custommers = data.Custommers;
		this.Suppliers = data.Suppliers;
		this.Prospects = data.Prospects;
		this.Products = data.Products;
		this.PriceLists = data.PriceLists;
		this.Stock = data.Stock;
		this.Sales = data.Sales;
		this.FrequencyDocuments = data.FrequencyDocuments;
		this.SaleRows = data.SaleRows;
		this.Purchases = data.Purchases;
		this.PurchaseDocuments = data.PurchaseDocuments;
		this.PurchaseDocumentRows = data.PurchaseDocumentRows;
		this.Bank = data.Bank;
		this.Bookkeeping = data.Bookkeeping;
		this.Crm = data.Crm;
		this.Projects = data.Projects;
		this.Calendar = data.Calendar;
		this.Tasks = data.Tasks;
		this.Car = data.Car;
		this.Settings = data.Settings != undefined ? data.Settings : true;
	}

	public getJSON(){
		return {
			Dashboard: this.Dashboard,
			Inbox: this.Inbox,
			Custommers: this.Custommers,
			Suppliers: this.Suppliers,
			Prospects: this.Prospects,
			Products: this.Products,
			PriceLists: this.PriceLists,
			Stock: this.Stock,
			Sales: this.Sales,
			FrequencyDocuments: this.FrequencyDocuments,
			SaleRows: this.SaleRows,
			Purchases: this.Purchases,
			PurchaseDocuments: this.PurchaseDocuments,
			PurchaseDocumentRows: this.PurchaseDocumentRows,
			Bank: this.Bank,
			Bookkeeping: this.Bookkeeping,
			Crm: this.Crm,
			Projects: this.Projects,
			Calendar: this.Calendar,
			Tasks: this.Tasks,
			Car: this.Car,
			Settings: this.Settings,
		};
	}

	getContactsVisible():boolean {
		return this.Custommers || this.Suppliers || this.Prospects;
	}

	getProductsVisible():boolean {
		return this.Products || this.PriceLists || this.Stock;
	}

	getSalesVisible():boolean {
		return this.Sales || this.SaleRows || this.FrequencyDocuments;
	}

	getPurchasesVisible():boolean {
		return this.Purchases || this.PurchaseDocuments || this.PurchaseDocumentRows;
	}

	getFinancialVisible():boolean {
		return this.Bank || this.Bookkeeping;
	}

	getToolsVisible():boolean {
		return this.Crm || this.Projects || this.Calendar || this.Tasks || this.Car;
	}
}